export const APPROVE_AMOUNT = '115792089237316195423570985008687907853269984665640564039457584007913129639935';
export const ADMIN_WALLETS = ['0x24f3354684F8d2b06Dc294D6155949d2D23ea5ce', '0x6e9637d3a3Dd30eAB2bEA9736B17373489afBc21'];
